var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "milk",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lait") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lait",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8996639,55.9778985 L42.1000825,55.9778985 L42.1000825,37.9997558 C42.1000825,35.7461383 45.3841568,28.3449539 47.7161159,23.8091459 C47.7161159,23.8091459 48.3214308,22.6518102 49.0074206,22.8166555 C50.001649,23.0557421 49.6670261,23.615239 49.6670261,23.615239 C49.6670261,23.615239 49.1538022,24.5288479 46.6300501,29.719641 C44.1943299,34.7297149 44.1420689,36.1744917 44.1420689,36.1744917 L57.6360753,36.1957384 L57.8996639,37.5098602 L57.8996639,55.9778985 Z M54.0917105,22.8984675 C54.0917105,22.8984675 54.8893258,22.4684047 54.8893258,21.9133036 C54.8893258,20.9225227 54.8893258,18.8886989 54.8893258,18.8886989 C54.8893258,18.0297942 54.8596436,18 54.0006342,18 L45.9993658,18 C45.1401027,18 45.1104205,18.0297942 45.1104205,18.8886989 C45.1104205,18.8886989 45.1104205,20.880762 45.1104205,21.9133036 C45.1104205,22.6566945 45.8337033,22.9121436 45.8337033,22.9121436 C45.8337033,22.9121436 40,34.2556933 40,37.9997558 C40,41.74797 40,56.4450821 40,56.4450821 C40,57.3037426 40.6963912,58 41.5551468,58 L58.4448532,58 C59.3038625,58 60,57.3037426 60,56.4450821 C60,56.4450821 60,41.2851822 60,37.9997558 C60,34.219061 54.0917105,22.8984675 54.0917105,22.8984675 L54.0917105,22.8984675 Z",
    id: "Fill-1",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("text", {
    id: "incl",
    xmlSpace: "preserve",
    x: 29,
    y: 143,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "incl.)"), /*#__PURE__*/React.createElement("text", {
    id: "lactose",
    xmlSpace: "preserve",
    x: 13,
    y: 121,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "(lactose"), /*#__PURE__*/React.createElement("text", {
    id: "text1",
    xmlSpace: "preserve",
    x: 36,
    y: 99,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "lait"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.caa48143a43a78d6bbed125b3f067bb8.svg";
export { ForwardRef as ReactComponent };